<editor
	[init]="{
		menubar: menu,
		toolbar: toolbar,
		plugins: plugins,
		branding: false
	}"
	[(ngModel)]="result"
	(ngModelChange)="resultChange.emit(result)"
></editor>
